<template>
    <div class="p-3 bg-white vh-100 border-end">
        <ul class="nav nav-pills side-menu-nav justify-content-center resp-alinhar-menu d-flex gap-1 flex-column">

            <ButtonNavBar :active="path == '/app'" @click="acessar_pagina('/app')" text="Aplicações" icon="ri-command-line"></ButtonNavBar>

            <ButtonNavBar :active="path == '/calculadora'" @click="acessar_pagina('/calculadora')" text="Calculadora" icon="ri-calculator-line"></ButtonNavBar>

            <ButtonNavBar :active="path == '/usuarios'" @click="acessar_pagina('/usuarios')" text="Usuários" icon="ri-group-line"></ButtonNavBar>

            <ButtonNavBar v-if="authStore.usuario.root"  :active="path == '/parcerias'" @click="acessar_pagina('/parcerias')" text="Parcerias" icon="ri-shake-hands-line"></ButtonNavBar>

            <ButtonNavBar v-if="authStore.usuario.root"  :active="path == '/modulos'" @click="acessar_pagina('/modulos')" text="Módulos" icon="ri-apps-2-line"></ButtonNavBar>

            <ButtonNavBar v-if="authStore.usuario.root"  :active="path == '/planos'" @click="acessar_pagina('/planos')" text="Planos" icon="ri-briefcase-line"></ButtonNavBar>

            <ButtonNavBar :active="path == '/doc'" @click="acessar_documentacao()" text="Documentação" icon="ri-article-line"></ButtonNavBar>

            <ButtonNavBar @click="longout()" text="Sair" icon="ri-logout-circle-r-line" textColor="danger"></ButtonNavBar>

        </ul>
    </div>
</template>

<script>
    import ButtonNavBar from '../widgets/ButtonNavBar.vue';
    import { useAuthStore } from '@/stores/auth.js'

    export default {
        props:{
            path:{
                type: String
            }
        },
        data(){
            return{
                authStore: useAuthStore()
            }
        },
        methods: {
            longout(){
                this.authStore.longout()
                this.$router.push('/')
            },
            acessar_pagina(path){
                this.$router.push(path)
            },
            acessar_documentacao(){
                window.open(`${(window.__env__ && window.__env__.VUE_APP_API_URL) || process.env.VUE_APP_API_URL}/doc`,`_blank`)
            }
        },
        components: {ButtonNavBar}
    }   
</script>